let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xQ7N")).then(() => parcelRequire('1cWz7'));